import WhyRd from "../../components/Board/WhyRd";

export default function WhyRdPage() {
  return <WhyRd />;
}
